import { render, staticRenderFns } from "./product-details.vue?vue&type=template&id=2a57890a&scoped=true&"
import script from "./product-details.vue?vue&type=script&lang=js&"
export * from "./product-details.vue?vue&type=script&lang=js&"
import style0 from "./product-details.vue?vue&type=style&index=0&id=2a57890a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a57890a",
  null
  
)

export default component.exports